import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { v4 } from 'uuid'

import { notificationDelay } from '../constants'
import { useNotificationStore } from '../infrastructure'
import { Notification } from '../types'

const useNotifications = () => {
  const { t: te } = useTranslation('error')

  const notifications = useNotificationStore((state) => state.notifications)
  const addNotfication = useNotificationStore((state) => state.addNotfication)
  const removeNotfication = useNotificationStore((state) => state.removeNotfication)

  const createNotification = useCallback(
    (notification: Omit<Notification, 'uuid'>) => {
      const uuid = v4()
      const timeoutId = setTimeout(() => removeNotfication(uuid), notificationDelay)

      addNotfication({ ...notification, timeoutId, uuid })
    },
    [addNotfication, removeNotfication],
  )

  const deleteNotification = useCallback(
    (notification: Notification) => {
      if ('timeoutId' in notification) {
        clearTimeout(notification.timeoutId as ReturnType<typeof setTimeout>)
      }

      removeNotfication(notification.uuid)
    },
    [removeNotfication],
  )

  return { createNotification, deleteNotification, notifications, te }
}

export default useNotifications
